import { FormattedMessage, useIntl } from 'react-intl';
import { useListOrganizations } from '@/api/trafikportalen';
import Button from '@/components/core/Button';
import { WarningBanner } from '@/components/core/WarningBanner';
import { COLLECTION_TYPE_LABELS } from '@/helpers/collectionTypes';
import { buildPeriodPageSearch } from '@/helpers/periodPageSearch';
import { useOrganizationsMissingCurrentPeriod } from '@/hooks/useOrganizationsMissingCurrentPeriod';
import { useTenantConfiguration } from '@/hooks/useTenantConfiguration';
import { useTenantID } from '@/hooks/useTenantID';

export const SysadminMissingPeriodInfo = () => {
  const tenantId = useTenantID();
  const { formatMessage } = useIntl();
  const { studentCategoryOrder } = useTenantConfiguration();
  const { data: organizations, isLoading: organizationsLoading } =
    useListOrganizations();
  const { counts, isLoading } =
    useOrganizationsMissingCurrentPeriod(organizations);

  const missingCategories = studentCategoryOrder.filter(
    (collectionType) =>
      !organizationsLoading &&
      !isLoading[collectionType] &&
      counts[collectionType] > 0,
  );

  if (missingCategories.length === 0) return null;

  return (
    <div className="flex w-full flex-col gap-2">
      {missingCategories.map((collectionType) => {
        const categoryLabel = formatMessage(
          COLLECTION_TYPE_LABELS[collectionType],
        );

        return (
          <WarningBanner key={collectionType}>
            <span className="flex flex-col items-start gap-3">
              <FormattedMessage
                defaultMessage="{count, plural, one {# organisation med {category} saknar en aktiv eller kommande period.} other {# organisationer med {category} saknar en aktiv eller kommande period.}}"
                values={{
                  count: counts[collectionType],
                  category: categoryLabel,
                }}
              />
              <Button
                variant="filled"
                to="/$tenantId/periods"
                params={{ tenantId }}
                search={buildPeriodPageSearch(
                  collectionType,
                  'organizations',
                  studentCategoryOrder[0],
                )}
                aria-label={formatMessage(
                  { defaultMessage: 'Hantera perioder för {category}' },
                  { category: categoryLabel },
                )}
              >
                <FormattedMessage defaultMessage="Hantera perioder" />
              </Button>
            </span>
          </WarningBanner>
        );
      })}
    </div>
  );
};
